import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/ProductsApi" );

export const listProducts = ( attributeId ) => instance.get( `GetProducts?attributeId=${attributeId}` );
